/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_variations = /** @type {(inputs: {}) => string} */ () => {
	return `Velikost`
};

const da_variations = /** @type {(inputs: {}) => string} */ () => {
	return `Størrelse`
};

const de_variations = /** @type {(inputs: {}) => string} */ () => {
	return `Größe`
};

const en_variations = /** @type {(inputs: {}) => string} */ () => {
	return `Size`
};

const es_variations = /** @type {(inputs: {}) => string} */ () => {
	return `Talla`
};

const fr_variations = /** @type {(inputs: {}) => string} */ () => {
	return `Taille`
};

const hu_variations = /** @type {(inputs: {}) => string} */ () => {
	return `Méret`
};

const it_variations = /** @type {(inputs: {}) => string} */ () => {
	return `Taglia`
};

const nl_variations = /** @type {(inputs: {}) => string} */ () => {
	return `Maat`
};

const pl_variations = /** @type {(inputs: {}) => string} */ () => {
	return `Rozmiar`
};

const pt_variations = /** @type {(inputs: {}) => string} */ () => {
	return `Tamanho`
};

const sv_variations = /** @type {(inputs: {}) => string} */ () => {
	return `Storlek`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const variations = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.variations(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("variations", locale)
	if (locale === "cs") return cs_variations(inputs)
	if (locale === "da") return da_variations(inputs)
	if (locale === "de") return de_variations(inputs)
	if (locale === "en") return en_variations(inputs)
	if (locale === "es") return es_variations(inputs)
	if (locale === "fr") return fr_variations(inputs)
	if (locale === "hu") return hu_variations(inputs)
	if (locale === "it") return it_variations(inputs)
	if (locale === "nl") return nl_variations(inputs)
	if (locale === "pl") return pl_variations(inputs)
	if (locale === "pt") return pt_variations(inputs)
	return sv_variations(inputs)
};